import classnames from 'classnames';
// eslint-disable-next-line import/no-unresolved
import Select from 'react-select';
import { isUndefined } from 'lodash';
import StandardComponents from '../StandardComponents';
import { OptionType, SelectValue } from '../types';
import s from '../Dropdowns.module.less';

export const rawSelectStyles = isDisabled => {
  return {
    menu: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    control: provided => ({
      ...provided,
      ...(isDisabled && {
        pointerEvents: 'all',
        cursor: 'not-allowed',
        borderColor: '#CCCCCC !important',
        backgroundColor: '#F7F7F7 !important',
      }),
    }),
    dropdownIndicator: provided => ({
      ...provided,
      ...(isDisabled && {
        color: '#A6A6A6 !important',
      }),
    }),
  };
};

export type Props = {
  name: string;
  placeholder?: string;
  value?: SelectValue;
  onChange: (val: SelectValue) => void;
  isClearable?: boolean;
  isSearchable?: boolean;
  options: OptionType[];
  onBlur?: () => void;
  components?: any;
  className?: string;
  inputId?: string;
  isMulti?: boolean;
  isDisabled?: boolean;
  menuPlacement?: 'auto' | 'bottom' | 'top';
};

const RawSelect = ({
  options,
  name,
  placeholder,
  value,
  onChange,
  isClearable,
  isSearchable = true,
  onBlur,
  isDisabled,
  components = {},
  className,
  menuPlacement = 'bottom',
}: Props) => {
  const getValue = () => {
    // guard clause so that this can be uncontrolled if needed
    if (isUndefined(value)) return value;

    const foundValue = options.find(option => option.value === value);
    return foundValue || null;
  };

  return (
    <Select
      name={name}
      className={classnames(s.select, className)}
      placeholder={placeholder}
      value={getValue()}
      onChange={(option: OptionType | null) => {
        const newValue = option ? option.value : null;
        onChange(newValue);
      }}
      onBlur={onBlur}
      options={options}
      isOpen
      isClearable={isClearable}
      isSearchable={isSearchable}
      inputId={name}
      isDisabled={isDisabled}
      components={{
        ...StandardComponents,
        ...components,
      }}
      styles={rawSelectStyles(isDisabled)}
      menuPlacement={menuPlacement}
    />
  );
};

export default RawSelect;
